import { NotificationBar } from '../../../components';
import { ToastStatus, ToastSync } from '../toast.type';
import style from './toast-notification.module.scss';
import { getToastErrorDetails } from './toast-notification.function';

type ToastNotificationProps = {
  toast: ToastSync;
  closeToast: () => void;
};

const mapToastStatus = (toastStatus: ToastStatus) => {
  switch (toastStatus) {
    case 'error':
      return NotificationBar.STATUS.ERROR;
    case 'info':
      return NotificationBar.STATUS.INFO;
    case 'success':
      return NotificationBar.STATUS.SUCCESS;
    case 'alert':
      return NotificationBar.STATUS.ALERT;
    default:
      return NotificationBar.STATUS.DEFAULT;
  }
};

export const ToastNotification = ({ toast, closeToast }: ToastNotificationProps) => {
  const { isSupportError, errorMessage, supportIdText } = getToastErrorDetails(
    toast.status,
    toast.message
  );

  return (
    <NotificationBar
      className={style.toastMessage}
      title={toast.title}
      status={mapToastStatus(toast.status)}
      roundedTop
      roundedBottom
      variant={NotificationBar.VARIANT.TERTIARY}
      showDismiss={!toast.options?.disableDismiss}
      highlight={false}
      onDismiss={() => closeToast()}
      buttonPosition={NotificationBar.BUTTON_POSITION.BOTTOM}
      primaryButton={
        toast.options?.button
          ? {
              children: toast.options.button.title,
              onClick: () => toast.options?.button?.onClick(),
              variant: NotificationBar.VARIANT.SECONDARY
            }
          : undefined
      }
      subtitle={
        <>
          {isSupportError && (toast.status === 'error' || toast.status === 'alert') ? (
            <>
              <p>{errorMessage}</p>
              <span className={style.greyed}>{supportIdText}</span>
            </>
          ) : (
            toast.message
          )}
        </>
      }
    />
  );
};
